import { render, staticRenderFns } from "./IssueDescription.vue?vue&type=template&id=0d92159a"
import script from "./IssueDescription.vue?vue&type=script&lang=js"
export * from "./IssueDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports